interface RubricNumeralProps {
  value: number | string;
  className?: string;
}

// Latin digit → Devanagari digit. ० १ २ ३ ४ ५ ६ ७ ८ ९
const DEVANAGARI_DIGITS = ["०", "१", "२", "३", "४", "५", "६", "७", "८", "९"];

function toDevanagariDigits(value: number | string): string {
  return String(value).replace(/[0-9]/g, (d) => DEVANAGARI_DIGITS[Number(d)]!);
}

/**
 * RubricNumeral — a numeral set in sindoor, rendered in Devanagari
 * digits (०१२…). Rubrication: numbers are marked in red the way a
 * scribe would rubricate a chapter or verse count. Any Latin digits in
 * `value` are converted; other characters pass through untouched.
 */
export function RubricNumeral({ value, className = "" }: RubricNumeralProps) {
  return (
    <span className={`font-dev text-sindoor tabular-nums ${className}`}>
      {toDevanagariDigits(value)}
    </span>
  );
}
